export const PATH_SETTINGS = 'settings';
export const PATH_SETTINGS_PROFILE = '/settings';
export const PATH_SETTINGS_GENERAL = 'general';
export const PATH_SETTINGS_HELP = 'help';
export const PATH_CHANGE_PASSWORD = 'change-password';
